import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('approvePermissionStore')
@observer
class RoleManagement extends Component {
  state = {
  }
  componentDidMount() {
  }
  render() {
    const { approvePermissionStore } = this.props
    const { isFetching } = approvePermissionStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm />
          <SearchResult />
        </div>
      </Spin>
    );
  }
}
export default RoleManagement;
